import { useCallback } from 'react';

import {
  boardSwitcherSearchSharedState,
  boardSwitcherSharedState,
  useBoardSwitcherMode,
} from '@trello/board-switcher';
import { useOpenBoardPanel } from '@trello/split-screen';

export const useOpenBoardAndHideSwitcher = () => {
  const openBoardPanel = useOpenBoardPanel();

  const mode = useBoardSwitcherMode();

  return useCallback(() => {
    openBoardPanel();

    if (mode === 'modal') {
      boardSwitcherSharedState.setValue({
        isOpen: false,
      });
      boardSwitcherSearchSharedState.setValue({
        query: null,
      });
    }
  }, [mode, openBoardPanel]);
};
